/**
 * Gate for SFTP workflow-step connectivity UI (Story 3.3b / 3.5a):
 * **Test connection** button and view-only **Authentication** / **Source|Destination authentication** summary lines.
 * Backend must expose `POST .../workflow/workflow-step-test-connection` (see `Apis.TEST_WORKFLOW_STEP_CONNECTION`).
 *
 * Default **off** until rollout is ready. Set `VITE_ENABLE_WORKFLOW_STEP_TEST_CONNECTION=true` to show.
 */
export function isWorkflowStepTestConnectionUiEnabled(): boolean {
	const raw = String(import.meta.env.VITE_ENABLE_WORKFLOW_STEP_TEST_CONNECTION ?? "").trim().toLowerCase();
	if (raw === "true" || raw === "1" || raw === "yes") return true;
	return false;
}
